export default __webpack_public_path__ + "c75d0e49bda41c8483767edd0cdd8308.png";